function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "view");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "3_Benutzer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.3_Benutzer_Benutzer",
  transform: "translate(-984.000000, -304.000000)",
  fill: "#3E4C57",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Produktname_001",
  transform: "translate(330.000000, 106.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Bezeichnung-Copy",
  transform: "translate(380.000000, 160.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "view",
  transform: "translate(274.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8982813,4.81378125 C15.7553437,4.61825 12.349625,0.02609375 7.99990625,0.02609375 C3.6501875,0.02609375 0.2443125,4.61825 0.10153125,4.81359375 C-0.03384375,4.99909375 -0.03384375,5.2506875 0.10153125,5.4361875 C0.2443125,5.63171875 3.6501875,10.223875 7.99990625,10.223875 C12.349625,10.223875 15.7553437,5.6316875 15.8982813,5.43634375 C16.0338437,5.250875 16.0338437,4.99909375 15.8982813,4.81378125 Z M7.99990625,9.1689375 C4.795875,9.1689375 2.02084375,6.12103125 1.199375,5.124625 C2.01978125,4.12734375 4.789,1.08103125 7.99990625,1.08103125 C11.2037812,1.08103125 13.978625,4.12840625 14.8004375,5.12534375 C13.9800312,6.12259375 11.2108125,9.1689375 7.99990625,9.1689375 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99990625,1.96015625 C6.25484375,1.96015625 4.8350625,3.3799375 4.8350625,5.125 C4.8350625,6.8700625 6.25484375,8.28984375 7.99990625,8.28984375 C9.74496875,8.28984375 11.16475,6.8700625 11.16475,5.125 C11.16475,3.3799375 9.74496875,1.96015625 7.99990625,1.96015625 Z M7.99990625,7.234875 C6.83646875,7.234875 5.89003125,6.28840625 5.89003125,5.125 C5.89003125,3.96159375 6.8365,3.015125 7.99990625,3.015125 C9.1633125,3.015125 10.1097813,3.96159375 10.1097813,5.125 C10.1097813,6.28840625 9.16334375,7.234875 7.99990625,7.234875 Z",
  id: "Shape"
}))))));

var SvgHidePwd = function SvgHidePwd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHidePwd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hide_pwd.b9d55bf2.svg";
export { ForwardRef as ReactComponent };